export const questionIds = [
  "primary_friction",
  "friction_area",
  "affected_groups",
  "friction_impacts",
  "timing_intent",
  "desired_outcomes",
] as const;

export type QuestionId = (typeof questionIds)[number];
export type IntentId = "fixing_today" | "planning_tomorrow";
export type IntentLabel = "Fixing Today" | "Planning for Tomorrow";
export type SubmissionStatus = "New" | "Reviewing" | "Contacted" | "Closed";

export type AssessmentAnswers = {
  primary_friction: string[];
  friction_area: string[];
  affected_groups: string[];
  friction_impacts: string[];
  timing_intent: string[];
  desired_outcomes: string[];
  customFriction?: string;
  customOutcome?: string;
};

export type FrictionSnapshot = {
  title: "Your Friction Snapshot";
  intent: IntentLabel;
  summary: string;
  impactHeading: string;
  impactStatement: string;
  desiredStateHeading: "What better looks like";
  desiredStateStatement: string;
  nextStepHeading: "What happens next";
  nextStepStatement: string;
  generatedAt: string;
  plainTextVersion: string;
};

export type QuestionOption = {
  id: string;
  label: string;
  snapshotPhrase?: string;
  description?: string;
};

export type QuestionDefinition = {
  id: QuestionId;
  reviewLabel: string;
  heading: string;
  instruction: string;
  type: "single" | "multi";
  min: number;
  max: number;
  options: readonly QuestionOption[];
  validation: {
    empty: string;
    over?: string;
    custom?: string;
  };
};

export const emptyAnswers = (): AssessmentAnswers => ({
  primary_friction: [],
  friction_area: [],
  affected_groups: [],
  friction_impacts: [],
  timing_intent: [],
  desired_outcomes: [],
});

export type StoredAssessmentState = {
  version: 1;
  assessmentSessionId: string;
  currentStep: "landing" | "review" | "snapshot" | number;
  answers: AssessmentAnswers;
  reviewReturnState: boolean;
  generatedSnapshot?: FrictionSnapshot;
};

export type PublicSubmissionPayload = {
  fullName: string;
  businessName: string;
  workEmail: string;
  consent: true;
  answers: AssessmentAnswers;
  customFriction?: string;
  customOutcome?: string;
  clientSnapshot: FrictionSnapshot;
  clientSnapshotText: string;
  generatedAt: string;
  assessmentSessionId: string;
  referrer?: string;
  honeypot: string;
};
